const CATCH_ERROR = {
  error: "An unexpected error occurred. Please try again later.",
};

let urlprefix = import.meta.env.BASE_URL+"/api";
const videoPrefix = import.meta.env.BASE_URL + "/api/video";

export const getVideo = (appCode) =>
  new Promise((resolve, reject) => {
    fetch(`${videoPrefix}/${encodeURIComponent(appCode)}`, {
      method: "GET",
      credentials: "include",
      headers: { "Accept": "application/json" }
    })
      .then((response) =>
        response.json().then((res) => {
          if (!response.ok || res?.error) {
            reject(res?.error ? res : { error: "Failed to load video." });
          } else {
            resolve(res);
          }
        })
      )
      .catch(() => reject(CATCH_ERROR));
  });

export const submitForm = (data) => {
  return new Promise((resolve, reject) => {
    fetch(urlprefix + "/submitForm", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) =>
        response.json().then((res) => {
          if (res.error) {
            reject(res);
          } else {
            resolve(res);
          }
        })
      )
      .catch(() => {
        reject(CATCH_ERROR);
      });
  });
};

export const submitFormReg = (data) => {
  return new Promise((resolve, reject) => {
    fetch(urlprefix + "/submitFormReg", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) =>
        response.json().then((res) => {
          if (res.error) {
            reject(res);
          } else {
            resolve(res);
          }
        })
      )
      .catch(() => {
        reject(CATCH_ERROR);
      });
  });
};

export const requestCaptcha = (data) => {
  return new Promise((resolve, reject) => {
    fetch(urlprefix + "/requestCaptcha", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) =>
        response.json().then((res) => {
          if (res.error) {
            reject(res);
          } else {
            resolve(res);
          }
        })
      )
      .catch(() => {
        reject(CATCH_ERROR);
      });
  });
};

export const submitCaptcha = (data) => {
  return new Promise((resolve, reject) => {
    fetch(urlprefix + "/submitCaptcha", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ captcha: data }),
    })
      .then((response) =>
        response.json().then((res) => {
          if (res.error) {
            reject(res);
          } else {
            resolve(res);
          }
        })
      )
      .catch(() => {
        reject(CATCH_ERROR);
      });
  });
};

export const getPrepop = (token) => {
  return new Promise((resolve, reject) => {
    fetch(urlprefix + "/RequestDetails", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify( token ),
    })
      .then((res) => {
        res.json().then((json) => {
          if (json.error) {
            reject(json);
          } else {
            resolve(json);
          }
        });
      })
      .catch((err) => reject(err));
  });
};

export const dropdownLookup = (data) => {
  return new Promise((resolve, reject) => {
    fetch(urlprefix + "/dropdownLookup", {
      method: "GET",
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        reject(CATCH_ERROR);
      });
  });
};

export const sendCommunications = (data) => {
  return new Promise((resolve, reject) => {
    fetch(urlprefix + "/sendCommunications", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) =>
        response.json().then((res) => {
          if (res.error) {
            reject(res);
          } else {
            resolve(res);
          }
        })
      )
      .catch(() => {
        reject(CATCH_ERROR);
      });
  });
};

export const taxRegistration = (data) => {
  return new Promise((resolve, reject) => {
    fetch(urlprefix + "/taxRegistration", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) =>
        response.json().then((res) => {
          if (res.error) {
            reject(res);
          } else {
            resolve(res);
          }
        })
      )
      .catch(() => {
        reject(CATCH_ERROR);
      });
  });
};
